import { Box, Button, TextField, Typography } from "@mui/material";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { useContext, useEffect, useState } from "react";
import { DataContext } from "../../../context/data-provider";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../services/axios-instance";
import { EDIT_USER_URL } from "../../../services/endpoints";
import { multipartFormDataConfig } from "../../../assets/data/multipartFormDataConfig";
import { getUrlWithProfilePicture } from "../../utils/getUrlWithProfilePicture";
import FocalPointForm from "./FocalPointForm";
interface LogOutBlockParams {
    setSession: React.Dispatch<React.SetStateAction<null | string>>;
}
const LogOutBlock = ({ setSession }: LogOutBlockParams) => {
    const { currentUser, setCurrentUser } = useContext(DataContext);
    const navigate = useNavigate();

    const [editMode, setEditMode] = useState(false);
    const [focalPointSelect, setFocalPointSelect] = useState(false);

    const handleEditModeToggle = () => {
        setEditMode(!editMode);

        if (editMode) {
            handleEditUserInfo();
        }
    };

    const showFocalPoint = () => {
        setFocalPointSelect(true);
    };

    const hideFocalPoint = () => {
        setFocalPointSelect(false);
    };

    const [updatedText, setUpdatedText] = useState(currentUser.name);
    const handleInputChange = (event: {
        target: { value: React.SetStateAction<string> };
    }) => {
        setUpdatedText(event.target.value);
    };

    // upload profile picture
    const [uploadedPicture, setUploadedPicture] = useState<File | null>(null);
    const handlePictureUpload = (
        event: React.ChangeEvent<HTMLInputElement>
    ): void => {
        const file = event.target.files?.[0];
        if (file) {
            setUploadedPicture(file);
        }
    };

    const handleEditUserInfo = async () => {
        try {
            const formData = new FormData();

            formData.append("name", updatedText);
            uploadedPicture &&
                formData.append("profile_picture", uploadedPicture);

            const responseEditUser = await axiosInstance.post(
                EDIT_USER_URL,
                formData,
                multipartFormDataConfig
            );

            setCurrentUser(responseEditUser?.data?.data);
        } catch (error) {
            console.error(
                "An error occurred during the user info update:",
                error
            );
        }
    };

    const saveFocalPoint = async (focalPoint : string) => {
        try {
            const responseEditUser = await axiosInstance.post(EDIT_USER_URL,{
                    profile_picture_focal_point: focalPoint,
                }
            );

            setCurrentUser(responseEditUser?.data?.data);
        } catch (error) {
            console.error(
                "An error occurred during the user info update:",
                error
            );
        }
    };

    useEffect(() => {
        if (editMode) {
            setUpdatedText(currentUser.name);
        }
    }, [editMode, currentUser.name]);

    return (
        <Box
            sx={{
                mb: 5,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 0.8,
            }}
        >
            {editMode ? (
                <input
                    style={{
                        color: "#e8eced",
                        width: "80%",
                        margin: "auto",
                    }}
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    onChange={handlePictureUpload}
                />
            ) : (
                <img
                    style={{
                        height: 120,
                        width: 120,
                        objectFit: "cover",
                        objectPosition: currentUser?.profile_picture_focal_point ? currentUser?.profile_picture_focal_point : "center",
                        borderRadius: "50%"
                    }}
                    src={getUrlWithProfilePicture(currentUser?.profile_picture)}
                    onClick={showFocalPoint}
                />
              
            )}
            {/* <Typography
                component="h6"
                variant="body1"
                sx={{
                    color: "#e8eced",
                    width: "200px",
                    mb: 1,
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                }}
            >
                {editMode ? (
                    <TextField
                        sx={{
                            background: "#e8eced",
                        }}
                        value={updatedText}
                        onChange={handleInputChange}
                        autoFocus
                    />
                ) : (
                    <Typography
                        variant="h6"
                        fontWeight="bold"
                        sx={{
                            color: "#e8eced",
                            width: "200px",
                            mb: 1,
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textAlign: "center",
                        }}
                    >
                        {currentUser.name}
                    </Typography>
                )}
            </Typography> */}

            <Typography
                component="h6"
                variant="body1"
                sx={{
                    color: "custom.sidebarIconActive",
                    width: "200px",
                    mb: 1,
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                    fontWeight: editMode ? "normal" : "bold", // Added fontWeight conditionally
                }}
            >
                {editMode ? (
                    <TextField
                        sx={{
                            background: "custom.lightGray",
                        }}
                        value={updatedText}
                        onChange={handleInputChange}
                        autoFocus
                    />
                ) : (
                    currentUser?.name // Render the name directly
                )}
            </Typography>

            <Button
                color={editMode ? "success" : "warning"}
                onClick={handleEditModeToggle}
            >
                {editMode ? "Save" : "Edit"}
            </Button>
            <Button
                variant="contained"
                startIcon={<PowerSettingsNewIcon />}
                size="small"
                color="error"
                onClick={() => {
                    setSession(null);
                    localStorage.removeItem("token");
                    navigate("/");
                }}
            >
                Logout
            </Button>
            {focalPointSelect ? (
                <FocalPointForm showFocalPoint={focalPointSelect} image={getUrlWithProfilePicture(currentUser?.profile_picture)} hideFocalPoint={hideFocalPoint} saveFocalPoint={saveFocalPoint}></FocalPointForm>
            ) : <div></div> }
        </Box>
    );
};

export default LogOutBlock;
